<template>
	<div class="">
		<base-page-heading
			title="Model3d"
			subtitle=""
			class="d-print-none"
		>
			<template #extra>
				<b-button
					ref="model3dShow"
					type="submit"
					size="md"
					variant="secondary"
					@click="showModal"
				>
					<i class="fa fa-fw fa-plus" /> 	Create new
				</b-button>
			</template>
		</base-page-heading>

		<div class="row">
			<Model3dTable @routeModel3d="routeModel3d" />
		</div>
	</div>
</template>
